"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcreteNode = void 0;
const base_1 = require("./base");
const antlr_files_1 = require("../antlr_files");
const sheet_db_1 = require("../../sheet_db");
class ConcreteNode extends base_1.LeafNode {
    terminalType;
    isTextFormatted = false;
    constructor(originalNode) {
        super(originalNode);
        this.terminalType = originalNode.symbol.type;
        this._startPosition = originalNode.symbol.start + 1;
        this._endPosition = originalNode.symbol.stop;
        this._treeNodeType = base_1.TreeNodeType.CONCRETE_NODE;
    }
    accept(v) {
        if (v.visitConcrete)
            v.visitConcrete(this);
    }
    translate(_opts) {
        this.formatText();
        return this.translation;
    }
    toString() {
        this.formatText();
        return super.toString();
    }
    formatText() {
        if (this.isTextFormatted)
            return;
        this.isTextFormatted = true;
        if (this.terminalType === antlr_files_1.Parser.ARGS_SPLITTER) {
            // hard setting comma as arg splitter (replaces ;)
            this.abstractText = `,`;
            this.translation = `, `;
        }
    }
    getReturnType() {
        // TODO: improve return type recognition checking children types
        return sheet_db_1.ColumnType.STRING;
    }
    static createConcreteNode(text, parent) {
        const newNode = new ConcreteNode({
            getText: () => text,
            symbol: { start: 0, stop: 0, type: 0 },
        });
        newNode.parent = parent;
        return newNode;
    }
}
exports.ConcreteNode = ConcreteNode;
